<template>
  <v-col>
    <v-form @submit.prevent="handleSubmitForm" ref="form">
      <v-col>
        <label class="labels">{{ $t('sales.affiliates_program_information') }}</label>
        <v-col class="px-0">
          <BaseTextField
            :placeholder="$t('sales.affiliates_program_name_info_placeholder')"
            type="text"
            :label="$t('sales.affiliates_programname')"
            required
            class="textinput"
            v-model="name"
            :rules="[rules.required]"
          >
          </BaseTextField>
        </v-col>
        <v-col class="px-0">
          <BaseTextField
            :placeholder="$t('sales.affiliates_program_url_field_placeholder')"
            type="text"
            class="textinput"
            :label="$t('sales.affiliates_program_url_field')"
            required
            v-model="slug"
            :rules="[rules.required]"
            @input="formatSlug"
          >
          </BaseTextField>
        </v-col>
      </v-col>
      <v-col>
        <v-btn
          class="btn-color"
          :color="$config.dados.corinputs"
          style="color: white"
          type="submit"
        >
          {{ $t('sales.affiliates_program_continue') }}
        </v-btn>
      </v-col>
    </v-form>
  </v-col>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import mixins from "../../../mixins";
const { formRules } = mixins;
export default {
  name: "NameComponent",
  mixins: [formRules],
  components: {
    BaseTextField,
  },
  data() {
    return {
      name: "",
      slug: "",
      nameError: "",
      slugError: "",
      message: "Welcome to the Affiliates Program!",
    };
  },
  computed: {
    ...mapGetters(["dataProgram"]),
  },

  methods: {
    ...mapActions(["nextStepProgram", "showSnackbarError"]),
    ...mapMutations(["setDataProgram"]),
    handleSubmitForm() {
      if (!this.$refs?.form?.validate()) {
        this.showSnackbarError(this.$t('sales.affiliates_program_commissioning_required_fields'));
        return false;
      }
      this.setDataProgram({
        ...this.dataProgram,
        name: this.name,
        slug: this.slug,
      });
      this.nextStepProgram();
    },
    formatSlug() {
      this.slug = this.slug
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
    },
  },
};
</script>

<style scoped>
.labels {
  font-size: 16px;
  font-weight: 800;
}
</style>
